module.exports = __webpack_public_path__ + "aboutpage_design_webdesign_digitalfactory_website_professional_pictures_design_grid.jpg?7ac2e727dcfdb1340ed85a37bc22cefc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/digital _factory/aboutpage_design_webdesign_digitalfactory_website_professional_pictures_design_grid.jpg
// module id = 42
// module chunks = 0